<template>
  <div class="TopToolbarStack">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AuxHUD extends Vue {}
</script>

<style scoped lang="scss">
.TopToolbarStack {
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  bottom: auto;

  border-bottom: var(--separator-light);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  z-index: 101;
}
</style>
